<template>
  <generic-modal :title="$t('student inscription')" ref="generic_modal">
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="new"
          @click="
            mode = 'new';
            change_active_tab($event, this);
          "
        >
          <a>
            <i class="plus icon" aria-hidden="true"></i>
            <span>{{ $t("new student") }}</span>
          </a>
        </li>
        <li
          data-tab="existing"
          @click="
            mode = 'existing';
            change_active_tab($event, this);
          "
        >
          <a>
            <i class="student icon" aria-hidden="true"></i>
            <span>{{ $t("existing student") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="is-active" data-tab="new">
        <new ref="new" @form-valid="form_valid('new', $event)" />
      </div>
      <div class="is-hidden" data-tab="existing">
        <existant ref="existant" @form-valid="form_valid('existing', $event)" />
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  change_active_tab,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import Existant from "./Existant.vue";
import New from "./New.vue";

export default {
  name: "InscriptionModal",
  components: { GenericModal, Existant, New },
  data() {
    return {
      meta: {},
      mode: "new",
      error: "",
      is_form_invalid: true,
    };
  },
  computed: {},
  methods: {
    change_active_tab,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/student/inscription", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (v.mode == "new") {
        let data = v.$refs.new.get_data();
        put("/student/inscription", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        let data = v.$refs.existant.get_data();
        put("/student/inscription/existant", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.$refs.new.set_initial_state();
      v.$refs.existant.set_initial_state();
      // v.uuid = "";
    },
    birthdate_changed(date) {
      let v = this;
      v.meta.birthdate = date;
    },
    set_student(student) {
      let v = this;
      if (student) v.meta.student_id = student.student_id;
    },
    set_stage(stage) {
      let v = this;
      if (stage) v.meta.stage_id = stage.stage_id;
    },
    set_program(program) {
      let v = this;
      if (program) v.meta.program_id = program.program_id;
    },
    form_valid(source, value) {
      let v = this;
      if (v.mode == source) v.is_form_invalid = !value;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
